import axios from "axios";
import { useAuthStore } from "../stores/authStore";
import { handleError } from "../utils/errors";

export const api = axios.create({
    // @ts-ignore
    baseURL: import.meta.env.VITE_SPA_URL + "/api/v1",
    withCredentials: true, // required to handle the CSRF token
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        if (error.response) {
            // Sesja wygasła
            if (error.response.status === 401 || error.response.status === 419) {
                // Tylko jeśli jesteśmy zalogowani
                if (useAuthStore().isGuest) {
                    return Promise.reject(error.response);
                }
                useAuthStore().logout();
            } else if (error.response.status === 503) {
                // Serwer jest niedostępny | Maintenance
                location.reload();
            }
        } else {
            handleError(error);
        }

        return Promise.reject(error.response);
    }
);
